import { CartDescriptionException, CartExceptionType } from '@cargos/sprintpay-models';
import { CustomerReferenceFormErrorJSON } from '../models/customer-reference-form';

export const formCustomerReferenceErrors: CustomerReferenceFormErrorJSON = {
    poNumber: [
        {
            code: 'required',
            message: CartDescriptionException[CartExceptionType.CUSTOMER_REFERENCE_INVALID],
        },
        {
            code: 'preventedHTMLStr',
            message: 'HTML tags or URLs are not allowed',
        },
    ],
};
